import './styles/InsertScanPIDStyle.css';
import React, { useEffect, useCallback, useState } from 'react';
import {
  BaseInput,
  NavigationButton,
  ToastType,
  TopNav,
  TopNavToastMessage,
} from '../common';
import { languageMap } from '../../maps/languageMap';
import { useActions, useTypedSelector } from '../../hooks';
import { APIResponseStatusType, navigationPages } from '../../models/types';
import { useHistory } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import AWB from '../../resources/images/awb.png';
import {
  EntryAvailabilityRequestPOST,
  EntryAvailabilityResponsePOST,
} from '../../models/cruds';
import { apiErrorHandler, apiPOST } from '../../restApi';

const EMPTY_PID = 'Escanea o ingresa un número de pieza';
const INCORRECT_PID_FORMAT = 'Formato de pieza incorrecto';
const PID_PREFIX = 'JD';

const InsertScanPID: React.FC = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [pid, setPid] = useState('');
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [variableInError, setVariableInError] = useState('');
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const agentToken = useTypedSelector(({ session }) => {
    return session.dhlAgentToken;
  });
  const currentPackageCandidate = useTypedSelector(({ locker }) => {
    return locker.currentPackageCandidate;
  });
  const scanner = useTypedSelector(({ devices }) => {
    return devices.scanner;
  });
  const { updateCurrentLockerPosition, updateCurrentPackageCandidate } =
    useActions();
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  useEffect(() => {
    if (scanner) {
      scanner?.pullTriggerAsync().catch((error) => console.error(error));
    }
    let timer = setInterval(() => {
      if (scanner) {
        scanner?.pullTriggerAsync().catch((error) => console.error(error));
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [scanner]);
  const onScan = useCallback(
    (event: CustomEvent) => {
      console.log(event);
      if (!loading && event.detail) {
        let filteredScan = event.detail.replace('\n', '');
        filteredScan = filteredScan.replace('\r', '');
        if (filteredScan.includes(PID_PREFIX)) {
          setPid(filteredScan);
        }
        let timer = setTimeout(() => {
          scanner?.pullTriggerAsync().catch((error) => console.error(error));
        }, 2000);
        return () => clearTimeout(timer);
      }
    },
    [loading, scanner]
  );
  useEffect(() => {
    const addScannerEventListeners = () => {
      scanner?.addEventListener('scan', onScan as EventListener);
    };
    addScannerEventListeners();
  }, [scanner, onScan]);
  useEffect(
    () => () => {
      const removeScannerEventListeners = () => {
        scanner?.removeEventListener('scan', onScan as EventListener);
      };
      removeScannerEventListeners();
    },
    [scanner, onScan]
  );
  useEffect(() => {
    if (!loading && pid !== '') {
      requestPIDValidation();
    }
  }, [loading, pid]);
  useEffect(() => {
    const validatePID = async (pieceID: string) => {
      setLoading(true);
      let request = new EntryAvailabilityRequestPOST();
      let response: EntryAvailabilityResponsePOST = await apiPOST(
        request.buildURL(),
        request.generateContent(pieceID),
        request.generateConfig(agentToken)
      );
      let errorMsg = '';
      try {
        if (response.status === APIResponseStatusType.SUCCESS) {
          let entry = response.data.entryAvailability;
          if (
            entry &&
            entry.lockerPosition?.row &&
            entry.lockerPosition.column
          ) {
            updateCurrentLockerPosition(entry.lockerPosition);
            updateCurrentPackageCandidate(entry.packageCandidate);
            history.replace(`/${navigationPages.INSERT_PIECE}`);
            setLoading(false);
            return true;
          } else {
            //TODO check for unauth and refresh token
            errorMsg = 'Unauthorized';
          }
        } else {
          errorMsg = apiErrorHandler(response);
        }
      } catch (err: any) {
        errorMsg = err.toString();
      }
      console.log(errorMsg);
      setFeedbackMessage(errorMsg);
      setLoading(false);
      return false;
    };
    if (currentPackageCandidate.pieceNumber) {
      validatePID(currentPackageCandidate.pieceNumber);
    }
  }, [
    agentToken,
    history,
    currentPackageCandidate,
    updateCurrentLockerPosition,
    updateCurrentPackageCandidate,
  ]);
  const validatePID = async (pieceID: string): Promise<boolean> => {
    setLoading(true);
    let request = new EntryAvailabilityRequestPOST();
    let response: EntryAvailabilityResponsePOST = await apiPOST(
      request.buildURL(),
      request.generateContent(pieceID),
      request.generateConfig(agentToken)
    );
    let errorMsg = '';
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        let entry = response.data.entryAvailability;
        if (entry && entry.lockerPosition?.row && entry.lockerPosition.column) {
          updateCurrentLockerPosition(entry.lockerPosition);
          updateCurrentPackageCandidate(entry.packageCandidate);
          return true;
        } else {
          //TODO check for unauth and refresh token
          errorMsg = 'Unauthorized';
        }
      } else {
        errorMsg = apiErrorHandler(response);
      }
    } catch (err: any) {
      errorMsg = err.toString();
    }
    console.log(errorMsg);
    setFeedbackMessage(errorMsg);
    setLoading(false);
    return false;
  };
  const requestPIDValidation = async () => {
    if (pid === '') {
      setFeedbackMessage(EMPTY_PID);
      return;
    }
    if (!pid.includes('JD')) {
      setFeedbackMessage(INCORRECT_PID_FORMAT);
      return;
    }
    let pieceIdAPI = pid;
    if (pid.includes('JJ')) {
      pieceIdAPI = pid.substring(1);
    }
    if (await validatePID(pieceIdAPI)) {
      history.replace(`/${navigationPages.INSERT_PIECE}`);
      return;
    }
    setPid('');
    setLoading(false);
  };
  const handleKeypress = (e: any) => {
    //it triggers by pressing the enter key
    if (e.key === 'Enter') {
      requestPIDValidation();
    }
  };
  const renderImage = () => {
    if (loading) {
      return (
        <div className="insert-scan-awb-container">
          <div className="spinner-container">
            <Spinner className="spinner" animation="grow" variant="danger" />
          </div>
        </div>
      );
    }
    return (
      <div className="insert-scan-awb-container">
        <div className="insert-scan-image-awb-container">
          <img
            id="awb-image"
            className="insert-awb-image"
            src={AWB}
            alt="Guia"
          />
          <div
            onClick={() => requestPIDValidation()}
            className={`insert-scan-awb-image-pid-helper ${
              pid !== '' ? 'scanned' : ''
            }`}
          />
        </div>
      </div>
    );
  };
  const renderContent = () => {
    return (
      <div className="locker-content-container">
        <div className="locker-content-container-left">
          <div className="insert-scan-input-container">
            <BaseInput
              val={pid}
              inputLabel="Número de pieza"
              inputPlaceholder="JD01 4600 0073 9390 4269"
              inError={variableInError === 'pid'}
              maxLength={25}
              disabled={loading}
              onTextChange={(newVal: string) => {
                setVariableInError('');
                setFeedbackMessage('');
                setPid(newVal);
              }}
              handleKeypress={handleKeypress}
              extraClassContainer="no-padding-right full-width stretched"
              extraClass="placeholder-left"
            />
          </div>
        </div>
        <div className="locker-content-container-right">{renderImage()}</div>
      </div>
    );
  };
  return (
    <div id="insertScanPID" className="main-container">
      <TopNav dataCyPrefix="scan-awb" />
      <div className="content-container">
        <div className="main-content-container fullpage">
          <TopNavToastMessage
            toastText={feedbackMessage}
            toastType={ToastType.ERROR}
            resetMessage={() => setFeedbackMessage('')}
          />
          <div className="title-content-container">
            <p className="header nopadding nomargin">
              {languageMap.insert_scan_pid.title[language]}
            </p>
          </div>
          <div className="data-content-container">{renderContent()}</div>
          <div className="footer-container">
            <div className="footer-button-container">
              <NavigationButton
                buttonContent={
                  languageMap.insert_scan_pid.cancel_button[language]
                }
                buttonClass="navigation-button cancel-button"
                onClickButton={() => {
                  history.replace(
                    `/${navigationPages.AGENT_PROCESS_SELECTION}`
                  );
                }}
              />
            </div>
            <div className="footer-button-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { InsertScanPID };
